import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothSurface,
} from '../../../../../graphql/graphql';

export const Tooth16: ToothDataEntry = {
	[ToothView.PALATAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M224.5,53.7l-6.4,24.6-10.5,35.7-9.3,22.5C62.2,172.7,11.6,127.7,11.6,127.7l-4.3-15-2.4-11.9-1.7-16.4-.2-17.6.5-11.9,3.8-10.9,9-14,13.8-11.2,13.8-4.8h24.7s13.3,2.6,13.3,2.6l15.7,5.5,7.4-4.3,9.5-4.3,10.2-2.4,12.6-1.4,11.9-1.4,13.8-1.2,11.7,1.2,13.3,3.8,13.3,5.7,11.9,7.1,10.2,9.5,1,19.3h0Z',
			},
			[ToothSurface.Palatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M127.7,68.3a17,17 0 1,1 -34,0a17,17 0 1,1 34,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M163.3,8.7l12.6,1.1,9.5,2.5,9.4,3.5,9.2,4.1,8.3,5.3,6.4,4.9,4.8,7.8v19.1s-14,46.1-14,46.1h-31c-17,0-15.1-21.3-15.1-21.3V8.6s0,0,0,0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M66.3,16.1l.3,73.7c0,16.8-16.6,13.8-16.6,13.8H7s-1.9-11.3-1.9-11.3l-1.3-10v-21.6s1.4-5.9,1.4-5.9l3.3-9.9,5.4-9.7,7-7.3,8-6.2,8.3-3.8,10.3-2.1,18.7.3h.1Z',
			},
			[ToothSurface.CervicalPalatal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M198.1,136.5l-3.4,9.4c-121.7,43-176-3-176-3l-7.2-15.2c63.5,45.3,186.7,8.8,186.7,8.8h0Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M97.5,22c45.7,33.3,14.4,128.4,14.4,128.4,0,0,42.8-1.3,86.2-14l9.3-22.5,7.2-26.2,7.8-23,2.2-11.9v-9.2s-1.2-9.2-1.2-9.2l-10.2-9.5-11.9-7.1-13.3-5.7-13.3-3.8-11.7-1.2-25.7,2.6-22.8,3.8-16.9,8.6h-.1Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M11.5,127.7c33.7,26.7,100.5,22.8,100.5,22.8,30.8-106.9-14.4-128.4-14.4-128.4l-15.7-5.5-13.3-2.6h-24.7s-13.8,4.8-13.8,4.8l-13.8,11.2-9,14-3.8,10.9-.5,11.9.2,17.6,1.7,16.4,2.4,11.9,4.3,15h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'4.5 71.6 26.3 45.1 37.4 82 53.5 41.6 71.2 83.1 89.9 42.4 108.5 82.6 128.1 44 146.7 85.4 164.6 44.5 185.2 84.1 190.4 46.9 219.4 70.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'112.3 437.7 98.4 414 117 408.5 99.7 394.7 116.7 388.1 99.2 374.9 116.2 365.4 99.9 355.7 115.9 346.6 97.9 335.9 114.8 326.3 99.7 317.2 117.8 306.9 101.3 297.1 117.3 288.1 100.6 278.2 116 269.3 99.1 259.2 115.1 250.1 100.6 241.5 113.9 233.9 99 225 113.2 217.2 98.3 208.2 113.4 199.8 99.4 191.4 113.2 183.7 99.1 175.4 116.3 165.7 102.1 157 117 148.6 102.3 139.7 119 130.2 103.5 120.9 121.5 110.7 106.2 101.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'174.1 283.1 161.3 265.6 148.3 283.5 132.6 263.9 119.8 280.7 105.5 263.6 91.2 280.7 79.9 265.2 67.9 280.7 56.5 263.9 48 280.5',
			],
		},
	},
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M200,41h.1s2.2,8.5,2.2,8.5l1.2,9.3.2,18.3-3.7,29.4-2.4,11.8-5.1,14.6-6.1,12.4-6.1,14-6.1,11.8-3.7,5.3-3,3.2-4.1,4.1-4.1,3.9-4.9,3.5-6.9,2.6-10.1,2.8-5.1,1.2h-4.3s-9.5-.4-9.5-.4l-5.3.2-4.3-.2-6.9-1-13.8-.8-8.5-2-8.1-1.6-4.9-1-7.5-3.2-3.5-2.4-7.1-2.6-7.7-5.5-6.7-4.5-3.9-5.1-4.1-7.5-2.6-4.9-2.2-6.5-1.4-4.9-.6-7.1-.6-8.9.2-7.7.2-6.5,11-36.3s.8-6.7.8-7.3.8-4.9.8-4.9l1.2-9.5,2-3.5,1.8-4.5,1.6-2.6,4.1-4.3,5.9-5.3,6.3-5.5,8.5-4.7,5.5-3,6.1-2.6,6.9-1.8,4.7-.6h5.5s12.8-.2,12.8-.2l3.2-.8,4.5-1.2,6.7-2,4.5-1.6,5.9-1.6,3.2-1.4,5.9-1.8,3.5-.2s6.3-.4,7.7-.4,2.6.2,2.6.2l5.1,1,5.5,1.2,5.5,2,4.9,2.4,4.7,2.8,5.5,3,4.9,4.3,2.2,2.4,2.4,2.8,2.6,3.2,4.3,9.7h0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M183,155.5l-29.9-36.6c-17.7-26.4,11.3-45.2,11.3-45.2l35.9-32.8,3.3,12.5,1.1,12.7-.3,17.1-2.2,17.3-5.4,19.5-4.9,16-6,10.6-3,8.9h0Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M37.3,48.9l21.6,27.1,8.7,10.5c17.2,17.7-3.1,34.8-3.1,34.8l-3,2.7-39.1,30.9-3.9-19,.2-18.3.7-8.7,3.5-12.9,7.6-19.6,1.3-7.4,1.3-12.7,4.1-7.4h0Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M123.1,76.2c7.9,11.7,41.2-2.4,41.2-2.4l35.9-32.8-2.1-6.7-5.7-8.1-8.9-7.4-11.6-7.2-16.8-6.1-15.3.2-26,8.5c-1.5,38.2,1.4,50.3,9.3,62Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M113.9,14c-1.9,35.6,9.3,62,9.3,62,0,0-14.1-20.9-34.8,1.5-6.3,6.8-29.5-1.7-29.5-1.7l-21.6-27.1,3.9-8.5,6.5-6.1,8.7-6.3,10.5-5.7,12.2-4.1,11.6-1.7,14.6.7,8.5-2.8v-.2Z',
			},
			[ToothSurface.DistoPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M22.3,154.9l39.1-30.9,11.6-5.3s-2.1,2.8-.4,9c1.2,4.2,4.2,10,10.8,17.6,16.7,19,14.2,51.7,14.2,51.7l-12.1-1.1-14.9-2.9-18-7.2-14-9-10.5-11.8-5.7-10.1h-.1Z',
			},
			[ToothSurface.MesioPalatalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M97.7,197c.7-36.3-14.2-51.7-14.2-51.7,0,0-18.4-16.5-10.3-26.6-.2,0,.8-3.9,11.4-3.8,10.6,0,10.4,9.1,22.2,9.1,11.8,0,16.9-10.9,27.1-10.9,10.2,0,19.1,5.8,19.1,5.8l29.9,36.6-9.9,18.1-8.9,10.1-13.1,9.7-17.3,3.7h-36,0Z',
			},
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M164.1,73.6c-35.9,27-.6,53.2-11.3,45.2,0,0-10.4-5.8-19.1-5.8-8.7,0-13.9,10.9-27.1,10.9-13.2,0-18.2-9.1-22.2-9.1s-23,9.1-23,9.1l3-2.7c24.6-22.4-8.6-45.2-5.6-45.3s22,10.4,29.5,1.7,23.2-17.6,34.8-1.5c8.1,11.3,41.2-2.4,41.2-2.4h-.2Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Vertical}`]: [
				'198.3 109.9 175.8 83.7 170.3 124 152.6 75.8 139 124 122.6 73.3 107.2 121 90.7 73.3 76 121.6 59.9 73.3 47.8 120.3 38.5 81.9 21 110.5',
			],
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M12.7,371.3c113.1-21.6,190.9,17.9,190.9,17.9l17.2,40.7,4.4,19,1,11.3-1.3,11.5-4.1,11-11.3,10-18.7,6.2-18.5,4.1-31.3-.3-22-6.9h-14.6s-26.1,4.4-26.1,4.4l-14.6-.3-7.7-.5-14.1-3.3-9.2-4.6-6.9-5.9-5.6-9.2-3.6-10.3-1.8-7.9-5.6-7.2-3.1-8.7-1.8-8.2-.8-9.2,1-9.7,2.1-15.9,1.5-12.8,4.6-15.1h0Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M198.4,377.3c-80.7-44.6-182.7-15.4-182.7-15.4l-2.9,9.5c113.6-21.6,190.9,17.9,190.9,17.9,0,0-5.3-12-5.3-12Z',
			},
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M124.8,426.3a16,16 0 1,1 -32,0a16,16 0 1,1 32,0Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M211.8,411.8l9.2,20.8,4.6,19.2-.8,19.2-4.6,11.3-9,8.5-16.7,7.2-23.8,5.1-16.4-.3v-77.1c0-12,11.3-13.8,11.3-13.8h46.1s.1-.1.1-.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M5.6,411.6l-2.1,6.9v15.9s3.8,13.8,3.8,13.8l6.9,9.7,3.3,12.8,5.6,11.5,9.2,9.2,11,4.9,27.9,4.1s.8-65.9.8-75.9c0-10-11.8-13.1-11.8-13.1H5.4s.2.2.2.2Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M107.9,495.5s-6.2-59.6-19-78.9c-12.8-19.3-3.3-51.5-3.3-51.5-31.9-1.6-72.7,6.4-72.7,6.4l-6.3,21-2.8,22.6v16.9s3.3,15.4,3.3,15.4l7.7,12,1.8,9.5,4.6,10.5,7.7,10,13.8,6.9,16.9,3.8h15.6s17.4-2.6,17.4-2.6l15.1-2.1h.2Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M203.7,389.3c-54.4-25.4-118.3-24.3-118.3-24.3,0,0-9.3,31.8,3.3,51.5,13.2,20.6,19,78.9,19,78.9l11.4.5,22,6.9,31.3.3,18.5-4.1,18.7-6.2,11.3-10,4.1-11,1.3-11.5-1-11.3-4.4-19-17.2-40.7h0Z',
			},
		},
		fractures: {
			[`${ToothFractureType.Crown},${ToothFracturePosition.Horizontal}`]: [
				'220.9 444.2 192.5 414.2 185.9 459.1 164.5 405.5 148.5 459.1 128.6 402.8 110.3 455.7 90.4 402.8 72.7 456.3 53.6 402.8 39.1 454.9 28.1 412 7.4 442.5',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Vertical}`]: [
				'75.3 369 88.6 359.1 71.1 351.4 84.5 341.4 68.4 334.2 81.1 324.7 66.6 318.3 79 309.1 62.3 301.7 74.5 292.8 61.1 286.9 73.3 277.9 58.7 271.5 71.5 262 57.9 256 70.7 246.5 57.8 240.7 70.4 231.5 54.9 224.7 69.5 213.9 52.4 208.6 67.1 198.7 51 192.2 66.1 181.6 48.6 174.7 63.4 161.5 45.9 156.2 58.5 146.3 44.2 138.4 57.2 125.4 40.7 120.3 51.7 105.6 36.3 99.7 42.4 80.9',
				'140.7 65.9 136.3 92.2 151.1 93 144.2 108.6 161.8 113.1 149.9 125 164.8 133.2 153.6 142.8 168.1 150.5 155.3 159.5 168.8 168.5 151.8 177.3 166.6 187 151.5 194.7 166.5 204.5 152 212.1 167.2 222.1 152.1 229.8 165.1 238.3 152.6 244.8 165.9 253.6 152.6 260.3 165.9 269.1 151.7 276.3 164.3 284.6 151.3 291.2 163.9 299.4 147.7 307.7 160.5 316.2 146.4 323.4 160.5 334 143.9 340.3 157.1 351.4 140.8 358.2 155 372.1',
			],
			[`${ToothFractureType.Root},${ToothFracturePosition.Horizontal}`]: [
				'193.2 234 176.6 215.3 160.4 234.3 141.2 213.5 124.7 233.8 112 213.3 95.4 232.8 78.6 214.1 66.6 233.2 48 213.5 37.5 231.2',
			],
		},
	},
};
